module.exports = __webpack_public_path__ + "img/product_kalsiy_CS.f4014507.png";